
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/social-security-retirement-benefits",
      function () {
        return require("private-next-pages/calculators/social-security-retirement-benefits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/social-security-retirement-benefits"])
      });
    }
  